/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  window.addEventListener('theme:variant:change', e => {
    const { target, detail: { variant }} = e

    if (!target.hasAttribute('data-quick-add-modal')) return;
    if (!target.querySelector('.js-email-input')) return;

    target.querySelector('.product-form').classList.remove('has-success')

    target.querySelector('.js-email-input')?.classList[variant.available ? 'add': 'remove']('hidden')
    target.querySelector('.js-atc-btn')?.classList[variant.available ? 'remove': 'add']('hidden')
    target.querySelector('.js-subscribe-btn')?.classList[variant.available ? 'add': 'remove']('hidden')

    if (variant.available) {
      target.querySelector('.js-email-input').setAttribute('disabled', '')
    } else {
      target.querySelector('.js-email-input').removeAttribute('disabled')
    }
  })
  document.addEventListener('click', e => {
    const button = e.target.closest('.js-subscribe-btn')
    if (!button) return;
    e.preventDefault();

    const form = e.target.closest('form')
    const emailInput = form.querySelector('.js-email-input')
    const formData = new FormData(form)
    const id = formData.get('id')
    const email = formData.get('email')
    const emailError = form.querySelector('.email-error');
    const msg = document.querySelector('.product__notification__message')

    for(var pair of formData.entries()){
      console.log(pair[0], pair[1]);
    }
    emailInput.classList.remove('error')
    emailError.style.display = 'none'
    msg.style.display = 'none'


    if (!validateEmail(email)) {
      emailInput.classList.add('error')
      emailError.style.display = 'block'
      return
    }

    button.classList.add('is-loading');

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          },
          channels: [
            'EMAIL'
          ]
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${id}`
            }
          }
        }
      }
    }

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${ window.theme.settings.klaviyoCompanyId }`, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2024-10-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(payload)
    }).then(res => res.text())
    .then(() => {
      emailInput.value = ''
      form.classList.add('has-success')
      msg.style.display = 'block'

    })
    .catch(err => console.error(err))
    .finally(() => {
      button.classList.remove('is-loading');

      setTimeout(() => {
        form.classList.remove('has-success')
        msg.style.display = 'none'
      }, 3000)
    });
  })

  /* Button update for new-product start */
    function updateCustomATCDisplay(variant, qty) {
      let price = 0
      const plus_btn = document.querySelector('.custom-atc-plus');
      const minus_btn = document.querySelector('.custom-atc-minus');
      if(variant){
        if (variant.available){
          const sub_check = document.getElementById('activate-subscription')?.checked;
          document.querySelector('.js-atc-btn').classList.remove('hidden');
          if(sub_check == true){
            plus_btn.style.display = 'none';
            minus_btn.style.display = 'none';
          }else{
            plus_btn.style.display = 'flex';
            minus_btn.style.display = 'flex';
          }
        }else{
          plus_btn.style.display = 'none';
          minus_btn.style.display = 'none';
        }
      }
      if (!variant){
        let price_text = document.querySelector('.custom-atc-total').getAttribute('data-price');
        let price_Float = parseFloat(price_text);
        price =  price_Float.toFixed(2);
      }else{
        price = variant.price / 100;
      }
      document.querySelector('.custom-atc-total').textContent = price ? (price * qty).toFixed(2) : '0.00';
      document.querySelectorAll('.custom-atc-qty').forEach(el => el.textContent = qty);
      const qtyInput = document.querySelector('input.custom-atc-qty');
      if (qtyInput) qtyInput.value = qty;
      const plus = document.querySelector('.custom-atc-plus');
      if (plus) {
        if (qty >= 10) {
          plus.classList.add('disabled');
          plus.setAttribute('aria-disabled', 'true');
        } else {
          plus.classList.remove('disabled');
          plus.removeAttribute('aria-disabled');
        }
      }
      if(minus_btn){
        if (qty == 1) {
          minus_btn.classList.add('disabled');
          minus_btn.setAttribute('aria-disabled', 'true');
          document.querySelector('.atc-main-wrap').classList.remove('has_more');
        } else {
          minus_btn.classList.remove('disabled');
          minus_btn.removeAttribute('aria-disabled');
        }
      }
    }
let customATCListenersAttached = false;
    function attachCustomATCListeners() {
        if (customATCListenersAttached) return; // already attached
        customATCListenersAttached = true;
      let qty = 1;
      let currentVariant = window?.Shopify?.currentVariant || null;

      const minus = document.querySelector('.custom-atc-minus');
      const plus = document.querySelector('.custom-atc-plus');
      if (!minus || !plus) return;

      minus.addEventListener('click', function(e) {
        qty = document.querySelector('input.custom-atc-qty').value;
        e.preventDefault();
        if (qty > 1) {
          qty--;
          updateCustomATCDisplay(currentVariant, qty);
        }
         if (qty == 1) {
          document.querySelector('.atc-main-wrap').classList.remove('has_more');
        }
      });

      plus.addEventListener('click', function(e) {
        qty = document.querySelector('input.custom-atc-qty').value;
        e.preventDefault();
        if (qty < 10) {
          qty++;
          updateCustomATCDisplay(currentVariant, qty);
          document.querySelector('.atc-main-wrap').classList.add('has_more');
        }
      });

      document.addEventListener('theme:variant:change', function(e) {
        if (!e.detail || !e.detail.variant) return;
        currentVariant = e.detail.variant;
        qty = 1;
        updateCustomATCDisplay(currentVariant, qty);
      });

      // Initial update
      if (currentVariant) updateCustomATCDisplay(currentVariant, qty);
    }

    document.addEventListener('DOMContentLoaded', function() {
       if (!document.body.classList.contains('template--new-product')) return;
      attachCustomATCListeners();
    });
    document.addEventListener("theme:cart:change", function(e) {
      if (!document.body.classList.contains('template--new-product')) return;
        const aty_qty = document.querySelectorAll('.custom-atc-qty');
        if(aty_qty.length > 0 ){
          aty_qty.forEach(el => el.textContent = 1);
          document.querySelector('input.custom-atc-qty').value = 1; 
          const sub_check = document.getElementById('activate-subscription') ? document.getElementById('activate-subscription').checked : false;
          if(sub_check == false){
            const priceText = document.querySelector('.product__price [data-product-price]').textContent;
            const single_price = parseFloat(priceText.replace(/[^\d.]/g, '')).toFixed(2);
            document.querySelector('.custom-atc-total').textContent = single_price;
            const plus_btn = document.querySelector('.custom-atc-plus');
            const minus_btn = document.querySelector('.custom-atc-minus');
            minus_btn.classList.add('disabled');
            plus_btn.classList.remove('disabled');
            document.querySelector('.atc-main-wrap').classList.remove('has_more');
          }
          attachCustomATCListeners();
        }
    });
    document.getElementById('activate-subscription')?.addEventListener('change', function(event) {
      if (!document.body.classList.contains('template--new-product')) return;
      const plus_btn = document.querySelector('.custom-atc-plus');
      const minus_btn = document.querySelector('.custom-atc-minus');
      const has_subscription = document.querySelector('.custom-atc-label.has-subscription');
      const no_subscription = document.querySelector('.custom-atc-label:not(.has-subscription)');
      if(event.target.checked == true){
        plus_btn.style.display = 'none';
        minus_btn.style.display = 'none';
        no_subscription.style.display = 'none';
        has_subscription.style.display = 'block';
      }else{
        plus_btn.style.display = 'flex';
        minus_btn.style.display = 'flex';
        has_subscription.style.display = "none";
        no_subscription.style.display = "block";
        const aty_qty = document.querySelectorAll('.custom-atc-qty');
        if(aty_qty.length > 0 ){
          aty_qty.forEach(el => el.textContent = 1);
        }
        const priceText = document.querySelector('.product__price [data-product-price]').textContent;
        const single_price = parseFloat(priceText.replace(/[^\d.]/g, '')).toFixed(2);
        document.querySelector('.custom-atc-total').textContent = single_price;
        document.querySelector('.custom-atc-total').setAttribute('data-price',single_price)
        minus_btn.classList.add('disabled');
        minus_btn.setAttribute('aria-disabled', 'true');
        plus_btn.classList.remove('disabled');
        plus_btn.removeAttribute('aria-disabled');
        document.querySelector('.atc-main-wrap').classList.remove('has_more');
      }
      document.querySelector('input.custom-atc-qty').value = 1; 
      attachCustomATCListeners();
    });

  /* Button update for new-product end */
    /* Test script for cart drawer start */
      var keepShoppingBtn = document.querySelector('.cart__buttons-all .cart__view');
      var cartDrawer = document.querySelector('cart-drawer');
      if (keepShoppingBtn && cartDrawer && typeof cartDrawer.closeCartDrawer === 'function') {
        keepShoppingBtn.addEventListener('click', function(e) {
          e.preventDefault();
          cartDrawer.closeCartDrawer();
        });
      }
    /* Test script for cart drawer end */

      /* -----------------------------
     Detect Back / Forward Navigation
     ----------------------------- */
  var isBackForwardNavigation = false;

  /* -----------------------------
     Silent refresh: update cart without opening drawer (only used on back/forward)
     ----------------------------- */
  var silentCartRefresh = false;
  var silentCartRefreshTimeout = null;

  /* -----------------------------
     Cart Request Lock
     Prevent duplicate requests
     ----------------------------- */
  var cartUpdating = false;

  /* Only block theme:product:added from opening the drawer when we are doing a back/forward cart refresh. All other times (real add-to-cart, etc.) work normally. */
  document.addEventListener('theme:product:added', function(e) {
    if (!silentCartRefresh) return;
    e.stopImmediatePropagation();
    silentCartRefresh = false;
    if (silentCartRefreshTimeout) {
      clearTimeout(silentCartRefreshTimeout);
      silentCartRefreshTimeout = null;
    }
  }, true);

  /* -----------------------------
     Refresh theme cart drawer (full HTML from section)
     ----------------------------- */
  function refreshCartDrawer() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getCart === 'function') {
      cartItems.getCart();
    }
  }

  /* -----------------------------
     Update Cart UI (count badges) – only updates the data attribute so theme formatting (e.g. "3 items") is not broken
     ----------------------------- */
  function updateCartUI(cart) {
    var count = cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.setAttribute('data-cart-count', String(count));
    });
  }

  /* -----------------------------
     Get Cart Data (count + drawer)
     On back/forward we call this to refresh so drawer shows current cart (drawer stays closed)
     ----------------------------- */
  function getCart(keepDrawerClosed) {
    if (cartUpdating) return;
    cartUpdating = true;
    if (keepDrawerClosed) {
      silentCartRefresh = true;
      if (silentCartRefreshTimeout) clearTimeout(silentCartRefreshTimeout);
      /* Safety: always reset flag after 2s so it can never get stuck */
      silentCartRefreshTimeout = setTimeout(function() {
        silentCartRefresh = false;
        silentCartRefreshTimeout = null;
      }, 2000);
    }

    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url + '.js' : '/cart.js';
    fetch(cartUrl)
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        updateCartUI(cart);
        refreshCartDrawer();
        cartUpdating = false;
        /* silentCartRefresh is cleared when we intercept theme:product:added, or by 2s safety timeout */
      })
      .catch(function(error) {
        refreshCartDrawer();
        cartUpdating = false;
        if (keepDrawerClosed) {
          silentCartRefresh = false;
          if (silentCartRefreshTimeout) {
            clearTimeout(silentCartRefreshTimeout);
            silentCartRefreshTimeout = null;
          }
        }
      });
  }

  /* -----------------------------
     Pageshow: detect back/forward and refresh cart so drawer is up to date (drawer stays closed)
     ----------------------------- */
  window.addEventListener('pageshow', function(event) {
    var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    if (
      event.persisted ||
      (navEntries && navEntries.length && navEntries[0].type === 'back_forward') ||
      (performance.navigation && performance.navigation.type === 2)
    ) {
      isBackForwardNavigation = true;
      setTimeout(function() { getCart(true); }, 150);
    }
  });

  // PLP filter labels: detect multiline labels accurately
      function markMultilineFilterLabels() {
        const labels = document.querySelectorAll(
          '.template-collection .sidebar__item label'
        );

        if (!labels.length) return;

        labels.forEach((label) => {
          const style = window.getComputedStyle(label);
          let lineHeight = parseFloat(style.lineHeight);

          // Fallback if line-height is 'normal'
          if (!lineHeight || isNaN(lineHeight)) {
            const fontSize = parseFloat(style.fontSize);
            lineHeight = fontSize * 1.2; // approximate fallback
          }

          const lines = Math.round(label.scrollHeight / lineHeight);

          if (lines > 1) {
            label.classList.add('filter-label--multiline');
          } else {
            label.classList.remove('filter-label--multiline');
          }
        });
      }

      // Run on page load
      document.addEventListener('DOMContentLoaded', markMultilineFilterLabels);

      // Run when Shopify sections reload
      document.addEventListener('shopify:section:load', markMultilineFilterLabels);

      // Run on resize (debounced for performance)
      let resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(markMultilineFilterLabels, 150);
      });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

})();

// Initialize custom multicolumn sliders (desktop & mobile)
function initCustomMulticolumnSliders(root = document) {
  const sliders = root.querySelectorAll('grid-slider[data-custom-multicolumn-slider]')
  sliders.forEach((slider) => {
    slider.dispatchEvent(
      new CustomEvent('theme:grid-slider:init', {
        bubbles: true,
      }),
    )
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initCustomMulticolumnSliders(document)
})

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target) return
  initCustomMulticolumnSliders(event.target)
})

document.addEventListener('DOMContentLoaded', () => {
  function initPredictiveSliderArrows(grid, prevBtn, nextBtn, attachClicks = true) {
    if (!grid || (!prevBtn && !nextBtn)) return

    const getScrollAmount = () => {
      const firstItem = grid.querySelector('.predictive-search__grid-item')
      return firstItem ? firstItem.getBoundingClientRect().width + 32 : 260
    }

    const updateArrowState = () => {
      const maxScrollLeft = grid.scrollWidth - grid.clientWidth
      const canScroll = maxScrollLeft > 0

      if (prevBtn) {
        prevBtn.classList.toggle('is-disabled', !canScroll || grid.scrollLeft <= 4)
      }

      if (nextBtn) {
        nextBtn.classList.toggle(
          'is-disabled',
          !canScroll || grid.scrollLeft >= maxScrollLeft - 4
        )
      }
    }

    if (attachClicks) {
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' })
        })
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' })
        })
      }
    }

    grid.addEventListener('scroll', updateArrowState)
    grid.addEventListener('wheel', (e) => {
      const maxScrollLeft = grid.scrollWidth - grid.clientWidth
      if (maxScrollLeft <= 0) return

      // Only act on horizontal swipe (trackpad or horizontal mouse wheel)
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        const scrollAmount = e.deltaX * 0.25 // control speed

        e.preventDefault()

        grid.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        })
      }
    })
    window.addEventListener('resize', updateArrowState)
    updateArrowState()
  }

  function refreshPredictiveResultsArrows() {
    const lists = document.querySelectorAll(
      '.predictive-search__results-panel.is-active .predictive-search__products__list--scroll'
    )
    lists.forEach(list => {
      const grid = list.querySelector('.grid')
      const prev = list.querySelector('.predictive-search__products-nav--prev')
      const next = list.querySelector('.predictive-search__products-nav--next')
      initPredictiveSliderArrows(grid, prev, next, {
        attachClicks: false,
        hideWhenNoScroll: true,
        flag: 'psResultsSliderArrowsInit',
      })
    })
  }

  const mobileMenu = document.querySelector('#header-menu')
  const accordionItems = mobileMenu ? mobileMenu.querySelectorAll('.accordion-item') : []

  accordionItems.forEach(accordionItem => {
    accordionItem.addEventListener('click', e => {
      if (e.target.classList.contains('accordion-item-link')) return
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()

      accordionItem.classList.toggle('is-open')
    })
  })

  const headerWrapper = document.querySelector('.header__wrapper')
  const desktopPredictiveSearch = document.querySelector('.header__desktop predictive-search')
  const desktopSearchInput = desktopPredictiveSearch
    ? desktopPredictiveSearch.querySelector('input[type="search"]')
    : null
  const desktopEmptyState = document.querySelector('.header__desktop .predictive-search--empty-desktop')
  const headerSearchClose = document.querySelector('.header-search-close')

  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches

  const RECENT_SEARCH_KEY = 'tbs_recent_searches'
  const BODY_SEARCH_OPEN_CLASS = 'search-is-open'

  const setBodySearchOpen = open => {
    document.body.classList.toggle(BODY_SEARCH_OPEN_CLASS, !!open)
  }

  const saveRecentSearch = term => {
    const clean = term && term.trim()
    if (!clean) return

    try {
      const existingRaw = window.localStorage.getItem(RECENT_SEARCH_KEY)
      const existing = existingRaw ? JSON.parse(existingRaw) : []

      const withoutTerm = Array.isArray(existing)
        ? existing.filter(t => String(t).toLowerCase() !== clean.toLowerCase())
        : []

      withoutTerm.unshift(clean)
      const limited = withoutTerm.slice(0, 6)

      window.localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(limited))
    } catch (e) {
      // localStorage not available; fail silently
    }
  }

  const renderRecentSearchesInto = container => {
    if (!container) return

    let searches = []
    try {
      const raw = window.localStorage.getItem(RECENT_SEARCH_KEY)
      searches = raw ? JSON.parse(raw) : []
    } catch (e) {
      searches = []
    }

    if (!Array.isArray(searches) || searches.length === 0) return

    container.innerHTML = ''
    searches.forEach(term => {
      const item = document.createElement('div')
      item.className = 'predictive-search__item'

      const link = document.createElement('a')
      link.className = 'predictive-search__link'
      link.href = `/search?q=${encodeURIComponent(term)}`
      link.textContent = term

      item.appendChild(link)
      container.appendChild(item)
    })
  }

  // Desktop header search: show popular searches / products when input focused and empty
  if (headerWrapper && desktopPredictiveSearch && desktopSearchInput && desktopEmptyState) {
    const openEmptyState = () => {
      if (!isDesktop()) return
      if (desktopSearchInput.value.trim().length === 0) {
        headerWrapper.classList.add('search-empty-open')
      }
    }

    const closeEmptyState = () => {
      headerWrapper.classList.remove('search-empty-open')
    }

    desktopSearchInput.addEventListener('focus', () => {
      setBodySearchOpen(true)
      openEmptyState()
    })

    desktopSearchInput.addEventListener('input', () => {
      if (desktopSearchInput.value.trim().length === 0) {
        openEmptyState()
      } else {
        closeEmptyState()
      }
    })

    desktopSearchInput.addEventListener('blur', () => {
      // Delay so clicks inside the empty state (e.g. product links) still work
      setTimeout(() => {
        const active = document.activeElement
        const insideSearch =
          (desktopEmptyState && active && desktopEmptyState.contains(active)) ||
          (desktopPredictiveSearch && active && desktopPredictiveSearch.contains(active))

        if (!insideSearch) {
          closeEmptyState()
          setBodySearchOpen(false)
        }
      }, 0)
    })

    // Close empty state when clicking outside header / empty panel
    document.addEventListener('click', event => {
      if (!headerWrapper.classList.contains('search-empty-open')) return
      const target = event.target
      const insideSearch =
        desktopPredictiveSearch.contains(target) || desktopEmptyState.contains(target)

      if (!insideSearch) {
        closeEmptyState()
        setBodySearchOpen(false)
      }
      setTimeout(refreshPredictiveResultsArrows, 600)
    })

    // Close with dedicated close button (X)
    if (headerSearchClose) {
      headerSearchClose.addEventListener('click', () => {
        closeEmptyState()
        desktopSearchInput.blur()
        setBodySearchOpen(false)
      })
    }
    // Close on Escape
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        closeEmptyState()
        setBodySearchOpen(false)
      }
    })

    // When the search form is reset (via clear button), reopen empty state
    const desktopSearchForm = desktopSearchInput.closest('form')
    if (desktopSearchForm) {
      desktopSearchForm.addEventListener('reset', () => {
        setTimeout(() => {
          openEmptyState()
        }, 0)
      })
      // Store recent searches per browser (desktop header form)
      desktopSearchForm.addEventListener('submit', () => {
        saveRecentSearch(desktopSearchInput.value)
      })
      // Delegate clicks for inline X and all CLOSE bars so it survives predictive-search re-renders
      document.addEventListener('click', event => {
        const closeTrigger = event.target.closest('.header-search-close, .desktop-search-close-bar')
        if (!closeTrigger) return

        desktopSearchForm.reset()
        closeEmptyState()
        desktopSearchInput.blur()
        setBodySearchOpen(false)
      })
    }

    // Keep behaviour in sync with viewport changes
    window.addEventListener('resize', () => {
      if (!isDesktop()) {
        closeEmptyState()
        setBodySearchOpen(false)
      }
    })
  }

  // Initialise empty-state sliders + recent searches for ALL contexts (desktop + mobile popdown)
  document.querySelectorAll('.predictive-search--empty-desktop').forEach(emptyContainer => {
    const emptyGrid = emptyContainer.querySelector(
      '.predictive-search__products__list--scroll .grid'
    )
    const emptyPrev = emptyContainer.querySelector('.predictive-search__products-nav--prev')
    const emptyNext = emptyContainer.querySelector('.predictive-search__products-nav--next')
    initPredictiveSliderArrows(emptyGrid, emptyPrev, emptyNext, true)

    const recentContainer = emptyContainer.querySelector('[data-recent-searches]')
    renderRecentSearchesInto(recentContainer)
  })
  function refreshYotpoInPredictiveSearch() {
    if (window.yotpo?.refreshWidgets) {
      window.yotpo.refreshWidgets()
    }
    if (window.yotpoWidgetsContainer?.initWidgets) {
      window.yotpoWidgetsContainer.initWidgets()
    }
  }

  let yotpoRefreshTimer = null
  let isRefreshing = false

  function scheduleYotpoRefresh() {
    if (isRefreshing) return
    if (yotpoRefreshTimer) clearTimeout(yotpoRefreshTimer)

    yotpoRefreshTimer = setTimeout(() => {
      isRefreshing = true
      refreshYotpoInPredictiveSearch()

      setTimeout(() => {
        isRefreshing = false
      }, 400)
    }, 150)
  }

  document.querySelectorAll('predictive-search').forEach(predictiveSearchEl => {
    const resultsEl = predictiveSearchEl.querySelector('[data-predictive-search-results]')
    if (!resultsEl) return

    const observer = new MutationObserver(() => {
      if (isRefreshing) return

      if (resultsEl.querySelector('.yotpo-widget-instance')) {
        scheduleYotpoRefresh()
      }

      if (resultsEl.querySelector('.predictive-search__products__list--scroll')) {
        setTimeout(refreshPredictiveResultsArrows, 100)
      }
    })

    observer.observe(resultsEl, { childList: true, subtree: false })
  })
  document.querySelectorAll('form.search-form').forEach(form => {
    form.addEventListener('submit', () => {
      const input = form.querySelector('input[type="search"]')
      if (!input) return
      saveRecentSearch(input.value)
    })
  })
  const headerSearchPopdownEl = document.querySelector('header-search-popdown')
  if (headerSearchPopdownEl) {
    const observer = new MutationObserver(() => {
      const isOpen = headerSearchPopdownEl.classList.contains('is-open')
      setBodySearchOpen(isOpen)
    })
    observer.observe(headerSearchPopdownEl, { attributes: true, attributeFilter: ['class'] })
  }
  // Predictive search results (non-empty): tabs and arrows
  document.addEventListener('click', event => {
    const navBtn = event.target.closest('[data-search-results-nav]')
    if (navBtn) {
      const direction = navBtn.getAttribute('data-search-results-nav')
      const list = navBtn.closest('.predictive-search__products__list--scroll')
      if (!list) return
      const grid = list.querySelector('.grid')
      if (!grid) return

      const firstItem = grid.querySelector('.predictive-search__grid-item')
      const amount = firstItem ? firstItem.getBoundingClientRect().width + 32 : 260

      grid.scrollBy({
        left: direction === 'prev' ? -amount : amount,
        behavior: 'smooth',
      })
      // After scroll animation, recompute arrow enabled/visibility state
      setTimeout(() => {
        const prev = list.querySelector('.predictive-search__products-nav--prev')
        const next = list.querySelector('.predictive-search__products-nav--next')
        initPredictiveSliderArrows(grid, prev, next, {
          attachClicks: false,
          hideWhenNoScroll: true,
          flag: 'psResultsSliderArrowsInit',
        })
      }, 350)
      return
    }

    const tab = event.target.closest('[data-search-tab]')
    if (tab) {
      const container = tab.closest('.predictive-search__column')
      if (!container) return
      const target = tab.getAttribute('data-search-tab')

      container
        .querySelectorAll('[data-search-tab]')
        .forEach(t => t.classList.toggle('is-active', t === tab))

      container.querySelectorAll('[data-search-panel]').forEach(panel => {
        panel.classList.toggle(
          'is-active',
          panel.getAttribute('data-search-panel') === target
        )
      })
      setTimeout(refreshPredictiveResultsArrows, 50)
    }
  })
  const searchDetails = document.querySelector('.search-button details');
  if (searchDetails) {
    // Usually, the clickable part of a <details> tag is the <summary>
    const searchSummary = searchDetails.querySelector('summary');
      searchSummary.addEventListener('click', function (event) {
          // Evaluate if it is currently open AT THE EXACT TIME of the click
          if (searchDetails.hasAttribute('open')) {                
              // Prevent the browser's default behavior of toggling the <details> tag
              event.preventDefault(); 

              // Trigger your custom close button logic safely
              const closeButton = document.querySelector('.search-popdown__close__button');
              if (closeButton) {
                  closeButton.click();
              }
          }
      });
  }
  // document.addEventListener("theme:cart:change", ()=> didcountNinjaCall() )
  refreshPredictiveResultsArrows()
})

const moneyFormat = "${{amount}}"

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "")
  }
  let value = ""
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || moneyFormat

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split(".")
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`)
    const centsAmount = parts[1] ? decimal + parts[1] : ""

    return dollarsAmount + centsAmount
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2)
      break
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0)
      break
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",")
      break
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",")
      break
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".")
      break
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", "")
      break
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",")
      break
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".")
      break
  }

  return formatString.replace(placeholderRegex, value)
}





(function() {
  const backCartBtn = document.querySelector('.cart__button-continue .btn');
  if(!Boolean(backCartBtn)) return
  const continueShoppingText = document.querySelector('.continue-shopping-text');
  const backButtonText = document.querySelectorAll('.back-shopping-text');
  const lastPageUrl = document.referrer;
  let url = sessionStorage.getItem("lastVisitedUrl");
  console.log(Boolean(url))

  if(Boolean(lastPageUrl)) {
    sessionStorage.setItem("lastVisitedUrl", lastPageUrl);
    url = sessionStorage.getItem("lastVisitedUrl");
  }

  if(Boolean(url)) {
    backCartBtn.href=url
    backButtonText.forEach(btn => {
      btn.style.display = 'flex'
    })
    continueShoppingText.style.display = 'none';

  } else {
    continueShoppingText.style.display = 'block';
    backButtonText.forEach(btn => {
      btn.style.display = 'none'
    })
  }

})()

// Scroll dots functionality for tabs-collections
document.addEventListener('DOMContentLoaded', function() {
  const tabsCollections = document.querySelector('.tabs-collections');
  if (!tabsCollections) return;

  function initScrollDots() {
    const sliders = tabsCollections.querySelectorAll('[data-scroll-dots]');
    
    sliders.forEach(slider => {
      const dotsContainer = slider.parentElement.querySelector('.tabs-collections__scroll-dots');
      if (!dotsContainer) return;
      
      const dots = dotsContainer.querySelectorAll('.scroll-dot');
      const items = slider.querySelectorAll('.grid-item');
      
      if (dots.length === 0 || items.length === 0) return;
      
      // Update active dot on scroll
      let scrollTimeout;
      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollLeft = slider.scrollLeft;
          const itemWidth = items[0].offsetWidth;
          const gap = parseInt(getComputedStyle(slider).gap) || 0;
          const currentIndex = Math.round(scrollLeft / (itemWidth + gap));
          
          dots.forEach((dot, index) => {
            if (index === currentIndex) {
              dot.classList.add('is-selected');
            } else {
              dot.classList.remove('is-selected');
            }
          });
        }, 100);
      });
      
      // Click dots to scroll
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const item = items[index];
          if (item) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        });
      });
    });
  }
  
  // Initialize on page load
  initScrollDots();
  
  // Re-initialize when tab changes
  const tabLinks = tabsCollections.querySelectorAll('.tab-link');
  tabLinks.forEach(tab => {
    tab.addEventListener('click', () => {
      setTimeout(initScrollDots, 100);
    });
  });
});

// Scroll dots for Quick link categories / section-columns (mobile slider, same as Collection carousels)
document.addEventListener('DOMContentLoaded', function() {
  const sectionColumnsSections = document.querySelectorAll('.section-columns');
  sectionColumnsSections.forEach(section => {
    const slider = section.querySelector('[data-scroll-dots]');
    if (!slider) return;
    const dotsContainer = section.querySelector('.section-columns__scroll-dots');
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('.scroll-dot');
    const items = slider.querySelectorAll('.grid-item');
    if (dots.length === 0 || items.length === 0) return;
    let scrollTimeout;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const scrollLeft = slider.scrollLeft;
        const itemWidth = items[0].offsetWidth;
        const gap = parseInt(getComputedStyle(slider).gap) || 0;
        const currentIndex = Math.min(Math.round(scrollLeft / (itemWidth + gap)), dots.length - 1);
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-selected', index === currentIndex);
        });
      }, 100);
    });
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const item = items[index];
        if (item) item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  });
});

// Scroll dots for Sticky Featured Collection (mobile slider)
document.addEventListener('DOMContentLoaded', function() {
  const stickySections = document.querySelectorAll('.sticky-featured-collection');
  stickySections.forEach(section => {
    const slider = section.querySelector('[data-scroll-dots]');
    if (!slider) return;
    const dotsContainer = section.querySelector('.sticky-featured-collection__scroll-dots');
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('.scroll-dot');
    const items = slider.querySelectorAll('.grid-item');
    if (dots.length === 0 || items.length === 0) return;
    let scrollTimeout;
    slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const scrollLeft = slider.scrollLeft;
        const itemWidth = items[0].offsetWidth;
        const gap = parseInt(getComputedStyle(slider).gap) || 0;
        const currentIndex = Math.min(Math.round(scrollLeft / (itemWidth + gap)), dots.length - 1);
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-selected', index === currentIndex);
        });
      }, 100);
    });
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const item = items[index];
        if (item) item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  });
});

// Custom JS-driven announcement ticker: smooth, no restart on hover
document.addEventListener('DOMContentLoaded', function() {
  const BASE_SPEED_MULTIPLIER = 0.2;   // < 1 = overall slower
  const HOVER_SPEED_MULTIPLIER = 0.25; // slightly slower than before on hover

  function initCustomTicker(frame) {
    if (!frame || frame.dataset.customTickerInitialised === 'true') return;
    const scale = frame.querySelector('[data-ticker-scale]');
    if (!scale) return;

    frame.dataset.customTickerInitialised = 'true';

    // Clone content so ticker is much longer than the visible area (avoid large empty gaps)
    const originalHTML = scale.innerHTML;
    const containerWidth =
      (frame.closest('.announcement__bar-outer') || frame).clientWidth ||
      frame.clientWidth ||
      scale.clientWidth;
    while (containerWidth && scale.scrollWidth < containerWidth * 8) {
      scale.insertAdjacentHTML('beforeend', originalHTML);
    }

    // Make sure we can move the scale smoothly
    scale.style.willChange = 'transform';

    let lastTime = null;
    let offset = 0;
    let width = scale.scrollWidth;
    let loopDistance = width;

    // Derive base speed from existing CSS animation time when possible
    const computedStyle = getComputedStyle(scale);
    const animationTimeVar = parseFloat(
      computedStyle.getPropertyValue('--animation-time') || '0'
    );

    // let baseSpeedPxPerSec;
    // if (animationTimeVar && width) {
    //   baseSpeedPxPerSec = (width / animationTimeVar) * BASE_SPEED_MULTIPLIER;
    // } else {
    //   baseSpeedPxPerSec = 60 * BASE_SPEED_MULTIPLIER;
    // }

    const FIXED_SPEED = 40; // px per second (adjust if needed)

    let baseSpeedPxPerSec = FIXED_SPEED;
    let currentSpeed = baseSpeedPxPerSec;
    const hoverSpeed = baseSpeedPxPerSec * HOVER_SPEED_MULTIPLIER;

    function updateWidth() {
      width = scale.scrollWidth;
      // Distance required so that when we wrap, the next cycle starts exactly
      // as the previous one ends (no full-blank frame).
      if (containerWidth) {
        loopDistance = Math.max(width - containerWidth, 0);
      } else {
        loopDistance = width;
      }
    }

    function step(timestamp) {
      if (!lastTime) {
        lastTime = timestamp;
      }
      const deltaSeconds = (timestamp - lastTime) / 1000;
      lastTime = timestamp;

      // Move left continuously
      offset -= currentSpeed * deltaSeconds;

      // Loop seamlessly just before the bar would be fully blank
      if (loopDistance > 0 && -offset >= loopDistance) {
        offset += loopDistance;
      }

      scale.style.transform = `translateX(${offset}px)`;
      requestAnimationFrame(step);
    }

    // Hover behaviour on the whole green bar (announcement__bar-outer)
    const hoverTarget =
      frame.closest('.announcement__bar-outer') ||
      frame.closest('.toolbar__text__frame') ||
      frame;

    hoverTarget.addEventListener('mouseenter', () => {
      currentSpeed = hoverSpeed;
    });

    hoverTarget.addEventListener('mouseleave', () => {
      currentSpeed = baseSpeedPxPerSec;
    });

    window.addEventListener('resize', () => {
      updateWidth();
    });

    updateWidth();
    requestAnimationFrame(step);
  }

  // Only run custom ticker on the page "Scrolling text" section (only_scrolling_text)
  // so the header announcement bar can display as a single static/slider bar without conflict
  document.querySelectorAll('.only_scrolling_text [data-ticker-frame]').forEach(initCustomTicker);

  // Refresh Yotpo widgets when "Recently viewed" section is loaded (content is injected via AJAX)
  document.addEventListener('theme:tab:check', function() {
    const recentHolder = document.querySelector('[data-recent-wrapper]:not(.is-hidden)');
    if (!recentHolder || !recentHolder.querySelector('.yotpo-widget-instance')) return;
    setTimeout(function() {
      if (window.Yotpo && typeof window.Yotpo.refreshWidgets === 'function') {
        window.Yotpo.refreshWidgets();
      }
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      }
    }, 300);
  });

  // Recently viewed: pagination dots on mobile (arrows removed via CSS)
  function initRecentlyViewedScrollDots(wrapper) {
    if (!wrapper) return;
    const slider = wrapper.querySelector('[data-scroll-dots]');
    const dotsContainer = wrapper.querySelector('.recently-viewed__scroll-dots');
    if (!slider || !dotsContainer) return;
    const items = slider.querySelectorAll('.grid-item');
    if (items.length === 0) return;
    if (wrapper.dataset.recentlyViewedDotsInit === '1') return;
    wrapper.dataset.recentlyViewedDotsInit = '1';

    dotsContainer.innerHTML = '';
    items.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'scroll-dot' + (i === 0 ? ' is-selected' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dotsContainer.appendChild(dot);
    });
    var dots = dotsContainer.querySelectorAll('.scroll-dot');
    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var scrollLeft = slider.scrollLeft;
        var itemWidth = items[0].offsetWidth;
        var gap = parseInt(getComputedStyle(slider).gap, 10) || 0;
        var currentIndex = Math.min(Math.round(scrollLeft / (itemWidth + gap)), dots.length - 1);
        dots.forEach(function(dot, index) {
          dot.classList.toggle('is-selected', index === currentIndex);
        });
      }, 100);
    });
    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        var item = items[index];
        if (item) item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }

  document.addEventListener('theme:tab:check', function() {
    var recentHolder = document.querySelector('[data-recent-wrapper]:not(.is-hidden)');
    if (!recentHolder) return;
    var slider = recentHolder.querySelector('[data-scroll-dots]');
    if (!slider) return;
    if (slider.querySelectorAll('.grid-item').length > 0) {
      initRecentlyViewedScrollDots(recentHolder);
    } else {
      var observer = new MutationObserver(function() {
        if (slider.querySelectorAll('.grid-item').length > 0) {
          observer.disconnect();
          initRecentlyViewedScrollDots(recentHolder);
        }
      });
      observer.observe(slider, { childList: true, subtree: true });
    }
  });

  // Related products: pagination dots on mobile (same behavior as Recently viewed)
  function initRelatedScrollDots(wrapper) {
    if (!wrapper) return;
    const slider = wrapper.querySelector('.grid--mobile-slider[data-grid-slider]');
    const dotsContainer = wrapper.querySelector('.related__scroll-dots');
    if (!slider || !dotsContainer) return;

    const items = slider.querySelectorAll('.grid-item');
    if (items.length === 0) return;
    if (wrapper.dataset.relatedDotsInit === '1') return;
    wrapper.dataset.relatedDotsInit = '1';

    dotsContainer.innerHTML = '';
    items.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'scroll-dot' + (i === 0 ? ' is-selected' : '');
      dot.setAttribute('aria-label', 'Go to related slide ' + (i + 1));
      dotsContainer.appendChild(dot);
    });

    var dots = dotsContainer.querySelectorAll('.scroll-dot');
    var scrollTimeout;

    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        var scrollLeft = slider.scrollLeft;
        var itemWidth = items[0].offsetWidth;
        var gap = parseInt(getComputedStyle(slider).gap, 10) || 0;
        var currentIndex = Math.min(Math.round(scrollLeft / (itemWidth + gap)), dots.length - 1);

        dots.forEach(function(dot, index) {
          dot.classList.toggle('is-selected', index === currentIndex);
        });
      }, 100);
    });

    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        var item = items[index];
        if (item) item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }

  function initRelatedScrollDotsOnPage() {
    document.querySelectorAll('.related__wrapper').forEach(function(wrapper) {
      var slider = wrapper.querySelector('.grid--mobile-slider[data-grid-slider]');
      var dotsContainer = wrapper.querySelector('.related__scroll-dots');

      if (slider && slider.querySelectorAll('.grid-item').length > 0 && dotsContainer) {
        initRelatedScrollDots(wrapper);
      } else {
        var observer = new MutationObserver(function() {
          var updatedSlider = wrapper.querySelector('.grid--mobile-slider[data-grid-slider]');
          if (!updatedSlider) return;

          if (updatedSlider.querySelectorAll('.grid-item').length > 0) {
            observer.disconnect();
            initRelatedScrollDots(wrapper);
          }
        });

        observer.observe(wrapper, { childList: true, subtree: true });
      }
    });
  }

  initRelatedScrollDotsOnPage();

  // Customers also bought: inject VIEW PRODUCT button when not present (JS fallback)
  function injectRelatedViewProductButtons(relatedSection) {
    if (!relatedSection) return;
    var items = relatedSection.querySelectorAll('.product-item');
    items.forEach(function(item) {
      if (item.querySelector('.product-item__view-product')) return;
      var info = item.querySelector('.product-information .product-item__info');
      if (!info) return;
      var link = item.querySelector('.product-information a[href*="/products/"]');
      if (!link) link = item.querySelector('.product-information [data-product-link]');
      var href = (link && (link.getAttribute('href') || link.getAttribute('data-product-link'))) || '#';
      var wrap = document.createElement('div');
      wrap.className = 'product-item__view-product';
      var btn = document.createElement('a');
      btn.className = 'btn btn--outline btn--primary';
      btn.href = href;
      btn.appendChild(document.createElement('span')).textContent = 'VIEW PRODUCT';
      wrap.appendChild(btn);
      info.appendChild(wrap);
    });
  }

  function runRelatedViewProductInjection() {
    document.querySelectorAll('.related__wrapper [data-related-section]').forEach(function(section) {
      injectRelatedViewProductButtons(section);
    });
  }

  runRelatedViewProductInjection();

  document.querySelectorAll('.related__wrapper').forEach(function(wrapper) {
    var relatedSection = wrapper.querySelector('[data-related-section]');
    if (!relatedSection) return;
    var observer = new MutationObserver(function() {
      injectRelatedViewProductButtons(relatedSection);
    });
    observer.observe(relatedSection, { childList: true, subtree: true });
  });
});